import React from 'react';
import Select, { GroupBase, MultiValue, OptionsOrGroups } from 'react-select';
import { colors } from '../../../../../../colorVars';
import { fontSizes } from '../../../../../atomic/text/Text';
interface Option {
  value: string;
  label: string;
}
type Props = {
  expirationDates: OptionsOrGroups<Option, GroupBase<Option>>;
  selectedDates: Option | Option[] | null;
  setSelectedDates: (value: MultiValue<Option>) => void;
};

export const ExpirationDateSelector = ({
  expirationDates,
  selectedDates,
  setSelectedDates,
}: Props) => {
  const styleObject = {
    menu: () => ({

    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: '1px',
    }),
    container: (provided) => ({
      ...provided,
      fontSize: fontSizes.body4,
      backgroundColor: colors.black,
      maxWidth: '150px',
      maxHeight: '80px',
      color: colors.lightGrey,
      margin: '5px 0 0 5px'
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      padding: 0,
    }),
    input: () => ({
      display: 'none',
    }),
    control: (provided) => ({
      ...provided,
      maxHeight: '80px',
      border: '1px solid white',
      fontSize: fontSizes.body4,
      backgroundColor: colors.black,
      maxWidth: '200px',
      color: colors.lightGrey,
      minHeight: '20px',
      borderRadius: 'none'
    }),
    multiValue: (provided) => ({
      ...provided,
      fontSize: fontSizes.body4,
      backgroundColor: colors.black,
      width: '60px',
      color: colors.lightGrey,
      opacity: 1,
      border: '1px solid white',
      display: 'flex',
      justifyContent: 'space-between',
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: colors.lightGrey,
      paddingLeft: '2px'
    }),
    menuList: (provided) => ({
      ...provided,
      border: '1px solid white',
      borderTop: 'none',
      backgroundColor: colors.black,
    }),
    option: (provided) => ({
      ...provided,
      padding: '0',
      borderBottom: '1px solid white',
      backgroundColor: colors.black,
    }),
    // clearIndicator: () => ({
    //   display: 'none'
    // }),
  };
  return (
    <div>
      <Select
        onChange={(value) => {
          setSelectedDates(value)}}
        value={selectedDates}
        isMulti
        options={expirationDates}
        styles={styleObject}
      />
    </div>
  );
};
